<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.dense" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="dense" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.vertical" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="vertical" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-text>
            <tab
              @change="log('change', 'tab', $event)"
              color="white"
              name="tab-1"
              v-if="tabs.length"
              :vertical-buttons-width="verticalButtonsWidth"
              :vertical="vertical"
              :bg-color="$root.colors.primary"
              :bg-color-lightness="$root.colors.bgColorLightness"
              :dense="dense"
              :padding-off="paddingOff"
              :height="height"
              :default-tab="0">
              <tab-panel :disabled="panel.disabled" :label="panel.label" :icon="panel.icon" v-for="(panel, index) in tabs" :key="index">
                <lorem-ipsum :repeats="20" />
              </tab-panel>
            </tab>
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageTab',
  data () {
    return {
      tabs: [],
      dense: false,
      vertical: false,
      paddingOff: false,
      height: '300px',
      verticalButtonsWidth: '140px'
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getExternalData('tab.json', 'tabs')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/tab.vue